import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// components
import FullscreenModal from 'components/fullscreenModal/FullscreenModal';
import RetrieveWireImportMap from './retrieve/retrieveWireImportMap';
import CreateImportMapsWrapper from './create/CreateImportMapsWrapper';
import ViewACHImportMap from './ViewAchImportMap/ViewACHImportMap';
import { WORKSPACES } from '../../../constants';

const MAP_TYPES = {
  wires: 'wires',
  ach: 'ach'
};

function WireImportActionSwitcherComponent({ history, match }) {
  const { action, id, mapType } = match.params;

  // mapType: [wires, ach]
  const baseURL = history?.location?.state?.previous || WORKSPACES.PYMTCNTR;
  const [modalVisible, setModalVisibility] = useState(false);

  const actions = {
    view: action === 'view' && id,
    create: action === 'create' && !id,
    modify: action === 'modify' && id
  };

  useEffect(() => {
    const shouldShowModal = Object.keys(actions).some((x) => actions[x]);

    setModalVisibility(shouldShowModal);
  }, [actions]);

  const closeModal = () => {
    history.push({ pathname: baseURL });
    setModalVisibility(false);
  };

  const modalProps = {
    showIcon: false,
    show: modalVisible,
    onHide: closeModal
  };

  const viewProps = {
    mapId: parseInt(id, 10),
    closeModal
  };

  return (
    <FullscreenModal {...modalProps} withParams>
      {({ modalRootRef }) => (
        <>
          {actions.view && mapType === MAP_TYPES.ach && (
            <ViewACHImportMap mapCode={id} closeModal={closeModal} />
          )}
          {actions.view && mapType === MAP_TYPES.wires && <RetrieveWireImportMap {...viewProps} />}
          {actions.create && (
            <CreateImportMapsWrapper modalRootRef={modalRootRef} {...viewProps} />
          )}
          {actions.modify && (
            <CreateImportMapsWrapper
              {...(mapType === MAP_TYPES.ach ? { mapCode: id } : {})}
              modalRootRef={modalRootRef}
              {...viewProps}
              modify
            />
          )}
        </>
      )}
    </FullscreenModal>
  );
}

WireImportActionSwitcherComponent.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired
};

const Routed = withRouter(WireImportActionSwitcherComponent);
export default Routed;
